module.exports = __webpack_public_path__ + "img/service-tab-img.61374288.png";